class DailyCollectionSwitcher {
  constructor(root) {
    this.root = root;
    this.queryKey = root.dataset.queryKey || 'collection';
    this.defaultPanel = root.dataset.defaultPanel || 'all';
    this.tabs = Array.from(root.querySelectorAll('[data-daily-collections-tab]'));
    this.panels = Array.from(root.querySelectorAll('[data-daily-collections-panel]'));
    this.handles = new Set(this.panels.map((panel) => panel.dataset.collectionHandle).filter(Boolean));

    this.onClick = this.onClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.tabs.forEach((tab) => tab.addEventListener('click', this.onClick));
    this.tabs.forEach((tab) => tab.addEventListener('keydown', this.onKeyDown));
    this.activate(this.initialHandle(), false);
  }

  initialHandle() {
    const params = new URLSearchParams(window.location.search);
    const requestedHandle = params.get(this.queryKey);

    if (requestedHandle && this.handles.has(requestedHandle)) {
      return requestedHandle;
    }

    if (this.handles.has(this.defaultPanel)) {
      return this.defaultPanel;
    }

    return (this.panels[0] && this.panels[0].dataset.collectionHandle) || 'all';
  }

  onClick(event) {
    event.preventDefault();
    const handle = event.currentTarget.dataset.collectionHandle;
    this.activate(handle, true);
  }

  onKeyDown(event) {
    const currentIndex = this.tabs.indexOf(event.currentTarget);
    if (currentIndex === -1) return;

    let nextIndex = null;

    switch (event.key) {
      case 'ArrowRight':
        nextIndex = (currentIndex + 1) % this.tabs.length;
        break;
      case 'ArrowLeft':
        nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        break;
      case 'Home':
        nextIndex = 0;
        break;
      case 'End':
        nextIndex = this.tabs.length - 1;
        break;
      default:
        return;
    }

    event.preventDefault();
    const nextTab = this.tabs[nextIndex];
    if (!nextTab) return;

    nextTab.focus();
    this.activate(nextTab.dataset.collectionHandle, true);
  }

  activate(handle, updateUrl) {
    const nextHandle = this.handles.has(handle) ? handle : this.initialHandle();

    this.tabs.forEach((tab) => {
      const isActive = tab.dataset.collectionHandle === nextHandle;
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
      tab.classList.toggle('is-active', isActive);
    });

    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.collectionHandle !== nextHandle;
    });

    if (updateUrl) {
      this.updateQuery(nextHandle);
    }
  }

  updateQuery(handle) {
    const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    const url = new URL(currentUrl, window.location.origin);
    const defaultAllQuery = 'collection=all';
    const allValue = defaultAllQuery.split('=')[1];
    url.searchParams.set(this.queryKey, handle === 'all' ? allValue : handle);
    const nextSearch = url.searchParams.toString();
    const nextUrl = `${url.pathname}${nextSearch ? `?${nextSearch}` : ''}${url.hash}`;
    history.replaceState(history.state, '', nextUrl);
  }
}

const initDailyCollectionSwitchers = () => {
  document.querySelectorAll('[data-daily-collections]').forEach((root) => {
    if (root.dataset.switcherReady === 'true') return;
    root.dataset.switcherReady = 'true';
    new DailyCollectionSwitcher(root);
  });
};

document.addEventListener('DOMContentLoaded', initDailyCollectionSwitchers);
document.addEventListener('shopify:section:load', initDailyCollectionSwitchers);
